import script from "./VideoQualitySetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoQualitySetting.vue?vue&type=script&setup=true&lang=ts"

import "./VideoQualitySetting.vue?vue&type=style&index=0&id=2b2d5a83&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2d5a83"]])

export default __exports__